import React from 'react';
import {Translate} from 'views/module';

const getStylesByStatus = (status) => {
  let styles = {
    background: '#f5f5f5',
    borderColor: '#9e9e9e',
    textColor: '#616161',
    label: <Translate expression='client.ClientCalendar.Calendar.Styles.Unconfirmed' />,
  };

  switch (status) {
    case 'shiftConfirmation':
      styles = {
        background: '#e6f0fc',
        borderColor: '#4285F4',
        textColor: '#1a73e8',
        label: <Translate expression='client.ClientCalendar.Calendar.Styles.ShiftConfirmation' />,
      };
      break;
    case 'clockInConfirmation':
      styles = {
        background: '#f3e5f5',
        borderColor: '#9c27b0',
        textColor: '#7b1fa2',
        label: <Translate expression='client.ClientCalendar.Calendar.Styles.ClockInConfirmation' />,
      };
      break;
    case 'clockOutConfirmation':
      styles = {
        background: '#e8f5e9',
        borderColor: '#34A853',
        textColor: '#1e8e3e',
        label: <Translate expression='client.ClientCalendar.Calendar.Styles.ClockOutConfirmation' />,
      };
      break;
    case 'unconfirmed':
      styles = {
        background: '#f5f5f5',
        borderColor: '#9e9e9e',
        textColor: '#616161',
        label: <Translate expression='client.ClientCalendar.Calendar.Styles.Unconfirmed' />,
      };
      break;
    case 'requestReschedule':
      styles = {
        background: '#fff8e1',
        borderColor: '#FBBC04',
        textColor: '#e37400',
        label: <Translate expression='client.ClientCalendar.Calendar.Styles.RequestedReschedule' />,
      };
      break;
    case 'requestCancel':
      styles = {
        background: '#ffebee',
        borderColor: '#EA4335',
        textColor: '#d93025',
        label: <Translate expression='client.ClientCalendar.Calendar.Styles.RequestedCancel' />,
      };
      break;
    case 'cancelled':
      styles = {
        background: '#ffebee',
        borderColor: '#EA4335',
        textColor: '#d93025',
        label: <Translate expression='client.ClientCalendar.Calendar.Styles.Cancelled' />,
      };
      break;
    case 'rescheduled':
      styles = {
        background: '#fff3e0',
        borderColor: '#FF9800',
        textColor: '#f57c00',
        label: <Translate expression='client.ClientCalendar.Calendar.Styles.Rescheduled' />,
      };
    default:
      break;
  }

  return styles;
};

export default getStylesByStatus;
